import { useCommonStore } from "@/store/common"
import { checkBridge, runBridge } from '@/common/jsBridgeUtils'

export const exitLogin = () => {
  // 目前无法公共使用 useCommonStore()， 暂不清楚此引入为何在createPinia之前
  const commonStore = useCommonStore()
  const hasExit = commonStore?.loginHasExit || false
  const globalWindow = window as any
  if (hasExit) {
    return
  }
  if (checkBridge('exitLogin')) {
    commonStore.$patch({
      loginHasExit: true
    })
    runBridge('exitLogin', {})
  } else {
    commonStore.$patch({
      loginHasExit: true
    })
    globalWindow?.login?.forceLogin((res: any) => {
      commonStore.$patch({
        loginHasExit: false
      })
      window.location.href = window.location.href.replace(/ticket=[^&]*/, `ticket=${res?.ticket}`)
      window.location.reload()
    })
  }
}

export const checkLogin = (callback: any) => {
  const commonStore = useCommonStore()
  const hasExit = commonStore?.loginHasExit || false
  const globalWindow = window as any
  globalWindow?.login?.isLogin((res: any) => {
    if (res.login) {
      window.location.href = window.location.href.replace(/ticket=[^&]*/, `ticket=${res?.ticket}`)
      callback && callback()
      window.location.reload()
    } else {
      if (hasExit) {
        return
      }
      if (checkBridge('exitLogin')) {
        commonStore.$patch({
          loginHasExit: true
        })
        runBridge('exitLogin', {})
      } else {
        commonStore.$patch({
          loginHasExit: true
        })
        globalWindow?.login?.login((res: any) => {
          commonStore.$patch({
            loginHasExit: false
          })
          window.location.href = window.location.href.replace(/ticket=[^&]*/, `ticket=${res?.ticket}`)
          callback && callback()
          window.location.reload()
        })
      }
    }
  })
}